export default "__VITE_ASSET__ce65331d__"